import { appendParameter as appendUrlParameter } from '@sosocio/frontend-utils/url';

export default appendUrlParameter;
